// test793
(793 && 0);
